export const navigation = [
  // {
  //   name: 'CHỨC NĂNG CHÍNH',
  //   url: '/dashboard',
  //   icon: 'icon-speedometer',
  //   // badge: {
  //   //   variant: 'info',
  //   //   text: 'NEW'
  //   // }
  // },
  {
    name: 'thongketrangthai',
    url: '/thongketrangthai',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'thongkechatluong',
        url: '/thongketrangthai/thongkechatluong',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 5
      },
      {
        name: 'trangthaiketnoi',
        url: '/thongketrangthai/rfmesh',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 6
      },
      {
        name: 'chatluongrouting',
        url: '/thongketrangthai/chatluongrouting',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 21
      },

      //     {
      //       name: 'Sơ đồ quan hệ RF-Mesh',
      //       url: '/thongketrangthai/quanherfmesh',
      //       icon: 'fa fa-caret-right fa-1', machucnang:

      //     },
      //     {
      //       name: 'Trạng thái kết nối RF-Mesh theo Trạm',
      //       url: '/thongketrangthai/rfmeshtheotram',
      //       icon: 'fa fa-caret-right fa-1', machucnang:
      //     },
      //     {
      //       name: 'Tỉ lệ online TB theo Tháng/Quý',
      //       url: '/thongketrangthai/tileonline',
      //       icon: 'fa fa-caret-right fa-1',machucnang:
      //     },
    ]
  },
  {
    name: 'ghichiso',
    url: '/ghichiso',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'dongbocmis',
        url: '/ghichiso/dongbocmis',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 7
      }
      // {
      //   name: 'Ghép chỉ số vào file CMIS',
      //   url: '/ghichisovarahoadon/ghepchisofilecmis',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Ghép chỉ số đổi giá?',
      //   url: '/ghichisovarahoadon/ghiepchisodoigia',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Ghép file XML giữa Web và Thiết bị',
      //   url: '/ghichisovarahoadon/ghepfile',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Xem chỉ số cmis ở ngày bất kỳ/tháng',
      //   url: '/ghichisovarahoadon/xemchiso',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // }
    ]
  },
  {
    // name: 'Giám sát các thông số điện',
    name: 'giamsat',
    url: '/giamsat',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'chisocongto',
        url: '/giamsat/chisocongtokh',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 8
        // badge: {
        //   variant: 'success',
        //   text: 'NEW'
        // }
      },
      {
        name: 'tsvhcto',
        url: '/giamsat/thongsovanhanh',
        icon: 'fa fa-caret-right fa-1', machucnang: 9
        // badge: {
        //   variant: 'secondary',
        //   text: '4.7'
        // }
      },
      {
        name: 'bieudophutai',
        url: '/giamsat/thongsophutai',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 10
        // badge: {
        //   variant: 'secondary',
        //   text: '4.7'
        // }
      },
      // {
      //   name: 'Dữ liệu đ.đo trạm biến áp',
      //   url: '/icons/simple-line-icons',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Chỉ số chốt ngày c.tơ',
      //   url: '/icons/simple-line-icons',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Chỉ số chốt tháng c.tơ',
      //   url: '/icons/simple-line-icons',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      {
        name: 'doctucthoidiemdo',
        url: '/giamsat/docdiemdo',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 11
      },
      {
        name: 'docdcu',
        url: '/giamsat/docdulieudcu',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 12
      },
      // {
      //   name: 'docdcuquakhu',
      //   url: '/giamsat/docdulieudcuquakhu',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 12
      // }
    ]
  },

  {
    // name: 'Nhập thông tin KH từ CMIS',
    name: 'nhapthongtincmis',
    url: '/nhapthongtinkh',
    icon: 'fa fa-align-justify',
    children: [
      {
        // name: 'Khai báo thông tin khách hàng CMIS',
        name: 'khaibaothongtinkh',
        url: '/nhapthongtinkh/khaibaokhachhangcmis',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 13
      },
      {
        // name: 'Điểm đo khai báo sai TT',
        name: 'diemdokhaibaosaitt',
        url: '/nhapthongtinkh/diemdokhaibaosai',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 14
      },
      {
        //  name: 'Khách hàng/Treo tháo công tơ ',
        name: 'khtreothao',
        url: '/nhapthongtinkh/khachhangtreothao',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 15
      }
      ,
      {
        // name: 'Khai báo danh mục trạm',
        name: 'khaibaodanhmuctram',
        url: '/nhapthongtinkh/danhmuctram',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 15
      }
      // {
      //   name: 'KH khai báo CMIS không được cập nhật',
      //   url: '/nhapthongtinkh/cmiskhongcapnhat',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // }
    ]
  },

  {
    name: 'baocao',
    url: '/baocao',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'thongkesanluong',
        url: '/baocao/thongkesanluong',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 18
      },
      {
        name: 'thongsochisokhachhang',
        url: '/baocao/thongsochisokhachhang',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 18
      },
      {
        name: 'thongkemangtai',
        url: '/baocao/thongkemangtai',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 22
      },
      {
        name: 'Báo cáo xử lý RF/GPRS',
        url: '/baocao/baocaoxuly',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 29
      },
      // {
      //   name: 'Báo cáo CSC tháng',
      //   url: '/baocao/baocaochisochotthang',
      //   icon: 'fa fa-caret-right fa-1',
      //    machucnang:31
      // },
      // {
      //   name: 'Báo cáo LoadProfile',
      //   url: '/baocao/baocaoloadprofile',
      //   icon: 'fa fa-caret-right fa-1',
      //    machucnang:32
      // }
      // {
      //   name: 'Xuất thông tin điểm đo',
      //   url: '/baocao/xuuatthongtin',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Nhật ký lắp đặt vận hành',
      //   url: '/baocao/nhatkylapdat',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      {
        name: 'Báo cáo sản lượng A0',
        url: '/baocao/baocaosanluongA0',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 33
      },
      {
        name: 'Báo cáo chất lượng điện năng',
        url: '/baocao/baocaochatluongdiennang',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 35
      },
      {
        name: 'baocaochatluong',
        url: '/#/tienich/baocaochatluong',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 32
      }
    ]
  },
  {
    // name: '',
    name: 'tienich',
    url: '/tienich',
    icon: 'fa fa-align-justify',
    children: [
      {
        // name: 'Quản lý người dùng',
        name: 'uoctinhtonthat',
        url: '/tienich/uoctinhtonthat',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      {
        // name: 'Khai báo danh mục trạm',
        name: 'xuatchiso',
        url: '/tienich/xuatchiso',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 20
      },
      {
        name: 'sosanhsanluong',
        url: '/tienich/sosanhsanluong',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 23
      },
      {
        // name: 'Bản đồ số',
        name: 'bandoso',
        url: '/tienich/bandoso',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 23
      },
      {
        // name: 'Giao nhận trạm 110kv',
        name: 'giaonhan110',
        url: '/tienich/giaonhan110',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      {
        // name: 'Giao nhận trạm 110kv',
        name: 'quanlymodemdcu',
        url: '/tienich/quanlymodemdcu',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      {
        name: 'giamsatrepeater',
        url: '/tienich/giamsatrepeater',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      {
        name: 'laychiso',
        url: '/tienich/laychiso',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      {
        name: 'laysanluongngay',
        url: '/tienich/laysanluongngay',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      // {
      //   name: 'nhatkylapdatvanhanh',
      //   url: '/tienich/nhatkylapdatvanhanh',
      //   icon: 'fa fa-caret-right fa-1',
      //   machucnang: 1
      // }
    ]
  },
  {
    // name: 'Quản lý',
    name: 'quanly',
    url: '/quanly',
    icon: 'fa fa-align-justify',
    children: [
      {
        // name: 'Quản lý người dùng',
        name: 'quanlynguoidung',
        url: '/quanly/nguoidung',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 1
      },
      {
        // name: 'Thống kê đăng nhập',
        name: 'thongkedangnhap',
        url: '/quanly/thongkedangnhap',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 16
      },
      // {
      //   name: 'Đánh giá chất lượng phân phối điện',
      //   url: '/quanly/danhgiachatluong',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Báo cáo vận hành',
      //   url: '/quanly/baocaovanhanh',
      //  icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Xuất thông tin điểm đo',
      //   url: '/quanly/xuathongtindiemdo',
      //   icon: 'fa fa-caret-right fa-1', machucnang:
      // },
      // {
      //   name: 'Nhật ký lắp đặt vận hành',
      //   url: '/quanly/nhatkylapdat',
      //   icon: 'fa fa-caret-right fa-1', machucnang: 
      // }
    ]
  },
  {
    name: 'canhbao',
    url: '/canhbao',
    icon: 'fa fa-align-justify',
    children: [
      {
        name: 'thietlapcanhbao',
        url: '/canhbao/thietlapcanhbao',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 27
      },
      {
        name: 'cauhinhnhan',
        url: '/canhbao/cauhinhnhan',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 5
      },


      {
        name: 'canhbaovanhanh',
        url: '/canhbao/canhbaovanhanh',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 92
      },
      {
        name: 'canhbaomatdien',
        url: '/canhbao/canhbaomatdien',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 5
      },
      {
        name: 'sukiencongto',
        url: '/canhbao/sukiencongto',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 28
      },
      {
        name: 'chisobatthuong',
        url: '/#/canhbao/chisobatthuong',
        icon: 'fa fa-caret-right fa-1',
        machucnang: 29
      },
    ]
  },
  {
    divider: true
  },
  // {
  //   title: true,
  //   name: 'Extras',
  // },
  // {
  //   name: 'Pages',
  //   url: '/pages',
  //   icon: 'fa fa-caret-right fa-1',         machucnang: 7
  //   children: [
  //     {
  //       name: 'Login',
  //       url: '/pages/login',
  //       icon: ''
  //     },
  //     {
  //       name: 'Register',
  //       url: '/pages/register',
  //       icon: ''
  //     },
  //     {
  //       name: 'Error 404',
  //       url: '/pages/404',
  //       icon: ''
  //     },
  //     {
  //       name: 'Error 500',
  //       url: '/pages/500',
  //       icon: ''
  //     }
  //   ]
  // },
  // {
  //   name: 'Download CoreUI',
  //   url: 'http://coreui.io/angular/',
  //   icon: 'icon-cloud-download',
  //   class: 'mt-auto',
  //   variant: 'success'
  // },
  // {
  //   name: 'Try CoreUI PRO',
  //   url: 'http://coreui.io/pro/angular/',
  //   icon: 'icon-layers',
  //   variant: 'danger'
  // }

];




// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-sidebar-nav/_nav.ts